/**
 * Collection App title bar — back button (history.back / collections index).
 */
(function (global) {
  const root = global.document;
  if (!root) return;

  function bindBack(nav) {
    const back = nav.querySelector('[data-offhoo-collection-back]');
    if (!back || back.dataset.offhooCollectionBackReady === 'true') return;
    back.dataset.offhooCollectionBackReady = 'true';

    back.addEventListener('click', (event) => {
      event.preventDefault();
      if (global.history.length > 1) {
        global.history.back();
        return;
      }
      const routes = global.Theme && global.Theme.routes;
      global.location.href = (routes && routes.collections_url) || '/collections';
    });
  }

  function boot() {
    root.querySelectorAll('[data-offhoo-collection-app-nav]').forEach(bindBack);
  }

  if (root.readyState === 'loading') {
    root.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : globalThis);
